export default {
    path: '/production',
    name: 'Production',
    component: () => import('@/layout/index.vue'),
    redirect: {
        name: 'ProductionCall',
    },
    meta: {
        title: '生产',
        icon: 'iconfont icon-jiancaixuangou',
        role: 'BACK_MENU1'
    },
    children: [{
            path: '/prodWhInventory',
            name: 'ProdWhInventory',
            meta: {
                title: "库存",
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M1'
            },
            component: () => import('@/views/Production/ProdWhInventory.vue')
        },
        {
            path: '/productionCall',
            name: 'ProductionCall',
            meta: {
                title: '生产叫料',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M2'
            },
            component: () => import('@/views/Production/ProductionCall.vue'),
        },
        {
            path: '/materialDistributionDetails',
            name: 'MaterialDistributionDetails',
            meta: {
                title: '配送详情',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M3'
            },
            component: () => import('@/views/Production/MaterialDistributionDetails.vue'),
        },
        {
            path: '/materialOnlineOrReturn',
            name: 'MaterialOnlineOrReturn',
            meta: {
                title: '通道库存',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M4'
            },
            component: () => import('@/views/Production/MaterialOnlineOrReturn.vue'),
        },
        {
            path: '/prodLocationAdjustment',
            name: 'ProdLocationAdjustment',
            meta: {
                title: '通道移库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M10'
            },
            component: () => import('@/views/Production/ProdLocationAdjustment.vue'),
        },
        {
            path: '/SemiFinishedProductManagement',
            name: 'SemiFinishedProductManagement',
            meta: {
                title: '半成品管理',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M9'
            },
            component: () => import('@/views/Production/SemiFinishedProductManagement.vue'),
        },
        // {
        //     path: '/FinishedProductHanding',
        //     name: 'FinishedProductHanding',
        //     meta: {
        //         title: '成品搬运',
        //         icon: 'el-icon-menu',
        //         role: 'BACK_MENU1_M7'
        //     },
        //     component: () => import('@/views/Production/FinishedProductHanding.vue'),
        // },
        // {
        //     path: '/ProductionMissionQuery',
        //     name: 'ProductionMissionQuery',
        //     meta: {
        //         title: '点对点搬运',
        //         icon: 'el-icon-menu',
        //         role: 'BACK_MENU1_M8'
        //     },
        //     component: () => import('@/views/Production/ProductionMissionQuery.vue'),
        // },
    ],
}